<app-table
    [data]="data"
    [displayedColumns]="displayedColumns"
    [currentSortOption]="currentSortOption"
    [loading]="loading"
    [noContentText]="noContentText"
    (dataSourceChangeInfinityScroll)="onDataSourceChangeInfinityScroll()"
    (sortOptions)="onSortOptions($event)"
    (goTo)="onGoTo($event)"
    (create)="onCreateFavorite($event)"
    (delete)="onDeleteFavorite($event)"
    (add)="onAdd($event)"
></app-table>
